import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import officeBearer from '../images/event/Office-bearer.jpg'
import { COLORS } from '../styles/theme'
import styled from 'styled-components'

const Congress = styled(Modal)`
.modal-content {
  border-radius: 0;
  border: 0;
  box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  text-align: center;
}
.modal-header {
  border: none;
  padding: 0 16px;
}
.modal-body {
  padding: 0;
  height: 100%;
}
`

export default function OfficeBearerModal({ showOfficeBearer, setShowOfficeBearer }) {

  return (
    
    <Congress
      show={showOfficeBearer}
      onHide={()=>setShowOfficeBearer(false)}
      size="xl"
      aria-labelledby="congress-bio"
      centered
    >
      <Modal.Body>
        <img src={officeBearer} width="100%" alt="Presidents of The Congress"/>
      </Modal.Body>
    </Congress>
  )
}


